import { useRouterState } from "@tanstack/react-router";
import { usePreviousPathTracker } from "@/lib/return-to";

/** Håller reda på vilken sida man kom ifrån. Renderar inget. */
export function NavHistoryTracker() {
  const href = useRouterState({ select: (r) => r.location.href });
  usePreviousPathTracker(href);
  return null;
}
